import { RouterManager } from '@aclass/admin/managers';
import { QuestionnaireStory } from '@aclass/admin/storage/actions';
import { IQuestionnaireData } from '@aclass/admin/storage/models';
import { IAdminState, IQuestionnaireModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class QuestionnaireEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:questionnaire-edit';

    private id: IQuestionnaireData['id'];

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IQuestionnaireModuleState['editPageRecordId']>(['questionnaireModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(QuestionnaireEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = parseInt(route.params.id);
        this.ngRdx.dispatch(QuestionnaireStory.dryRunEditPage(this.id));
    }
}
